var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewuserGift = function SvgNewuserGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    d: "M2.4 8.481v5.6a.8.8 0 0 0 .8.8h9.6a.8.8 0 0 0 .8-.8v-5.6M1.6 4.981h12.8a.3.3 0 0 1 .301.3v2.4a.3.3 0 0 1-.3.3H1.6a.3.3 0 0 1-.3-.3v-2.4a.3.3 0 0 1 .3-.3ZM9.006 2.115 8 4.88h2l1.36-.742c1.224-.667 1.13-2.453-.156-2.99a1.66 1.66 0 0 0-2.198.966ZM6.994 2.115 8 4.88H6L4.64 4.14c-1.224-.667-1.13-2.453.156-2.99a1.66 1.66 0 0 1 2.198.966ZM8 5.281v9.2"
  })));
};
export default SvgNewuserGift;